import {useCallback, useSyncExternalStore} from 'react';
import type {Editor} from 'grapesjs';
import {noop} from '@Utils/general.util';
import {getImageCropModeState, subscribeToImageCropMode} from '@EmailMakerReact/lib/email-maker-image-crop-library';
import type {EmailImageCropModeState} from '@EmailMakerReact/lib/email-maker-image-crop-library';

export function useImageCropMode(editor: Editor | null): EmailImageCropModeState | null {
  const subscribe = useCallback(
    (onStoreChange: () => void): (() => void) => {
      if (!editor) {
        return noop;
      }
      return subscribeToImageCropMode(editor, onStoreChange);
    },
    [editor]
  );
  const getSnapshot = useCallback((): EmailImageCropModeState | null => (editor ? getImageCropModeState(editor) : null), [editor]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
